import { ChangeDetectorRef, Component, HostListener, Input } from '@angular/core'
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    standalone: true,
    imports: [NgClass],
})
export class DropdownComponent {
	@Input() title: string
	@Input() position = 'bottom right'
	_show: boolean = false

	constructor(private cdr: ChangeDetectorRef) {}

	clickedInside($event: Event) {
		$event.preventDefault()
		$event.stopPropagation()
	}

	@HostListener('document:click')
	clickedOutside() {
		this._show = false
		this.cdr.detectChanges()
	}
}
